import { useEffect, useRef } from "react";

// Constelación animada del mockup aprobado (kit: constelacion).
export const Constellation = ({ density = 0.000075 }) => {
  const ref = useRef(null);
  useEffect(() => {
    const c = ref.current;
    const ctx = c.getContext("2d");
    const RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const FINE = window.matchMedia("(pointer: fine)").matches;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    let W = 0, H = 0, P = [], raf = 0;
    const mouse = { x: -999, y: -999 };
    const size = () => {
      const r = c.getBoundingClientRect();
      W = r.width; H = r.height; c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const n = Math.max(28, Math.min(120, Math.round(W * H * density)));
      P = Array.from({ length: n }, () => ({ x: Math.random() * W, y: Math.random() * H, vx: (Math.random() - 0.5) * 0.25, vy: (Math.random() - 0.5) * 0.25, r: 1 + Math.random() * 1.6, g: Math.random() < 0.22 }));
    };
    const ro = new ResizeObserver(size); ro.observe(c); size();
    const onMove = (e) => { const r = c.getBoundingClientRect(); mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top; };
    if (FINE) window.addEventListener("pointermove", onMove);
    const frame = () => {
      if (!document.hidden) {
        ctx.clearRect(0, 0, W, H);
        for (const p of P) {
          const dx = p.x - mouse.x, dy = p.y - mouse.y, d = Math.hypot(dx, dy);
          if (d < 140 && d > 0) { p.x += (dx / d) * 1.2; p.y += (dy / d) * 1.2; }
          p.x += p.vx; p.y += p.vy;
          if (p.x < 0) p.x = W; if (p.x > W) p.x = 0; if (p.y < 0) p.y = H; if (p.y > H) p.y = 0;
        }
        for (let i = 0; i < P.length; i++) for (let j = i + 1; j < P.length; j++) {
          const a = P[i], b = P[j], d = Math.hypot(a.x - b.x, a.y - b.y);
          if (d < 130) { ctx.strokeStyle = `rgba(224,185,112,${(1 - d / 130) * 0.22})`; ctx.lineWidth = 0.7; ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke(); }
        }
        for (const p of P) {
          const col = p.g ? "247,227,179" : "200,205,220";
          const grd = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 3);
          grd.addColorStop(0, `rgba(${col},${p.g ? 0.9 : 0.55})`); grd.addColorStop(1, `rgba(${col},0)`);
          ctx.fillStyle = grd; ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 3, 0, 7); ctx.fill();
        }
      }
      if (!RM) raf = requestAnimationFrame(frame);
    };
    frame();
    return () => { cancelAnimationFrame(raf); ro.disconnect(); window.removeEventListener("pointermove", onMove); };
  }, [density]);
  return <canvas ref={ref} aria-hidden="true" data-testid="onb-constellation" />;
};
